import { RestaurantTable } from "@/shared/utils/interfaces";
import { PrimitiveAtom, atom, useAtom, useSetAtom } from "jotai";

export const tableAtom = atom(undefined) as PrimitiveAtom<
  RestaurantTable | undefined
>;
const useTable = () => {
  const atom = useAtom(tableAtom);
  return atom;
};

export const useSetTable = () => useSetAtom(tableAtom);

export default useTable;
